// extracted by mini-css-extract-plugin
export default {"button":"button_button__zVIFI","primary":"button_primary__lp2td","secondary":"button_secondary__tedYt"};